// src/context/AuthContext.js
import React, { createContext, useState, useEffect } from 'react';
import API from '../api/client';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // 1️⃣ Rehidratar token y usuario desde localStorage
  const [isAuthenticated, setIsAuthenticated] = useState(() =>
    !!localStorage.getItem('accessToken')
  );
  const [accessToken, setAccessToken] = useState(null);
  const [user, setUser] = useState(() => {
    const u = localStorage.getItem('user');
    return u ? JSON.parse(u) : null;
  });

  // 2️⃣ login guarda token + userInfo
  const login = (accessToken, userInfo = {}) => {
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('user', JSON.stringify(userInfo));
    setIsAuthenticated(true);
    setUser(userInfo);
    console.log('[AuthContext] login() → isAuthenticated=true, token y user guardados', {
      accessToken,
      userInfo
   });
   // Asegurarnos de que API tenga el header tras un login manual
   API.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
  };

  // Función para actualizar los datos del usuario que ya tiene el contexto
  const updateUser = (newUserData) => {
    setUser(prev => {
      const updated = { ...prev, ...newUserData };
      // Guardamos el usuario completo ya mergeado
      localStorage.setItem('user', JSON.stringify(updated));
      return updated;
    });
  };

  // 3️⃣ logout limpia todho
  const logout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    setIsAuthenticated(false);
    setUser(null);
  };

  // Al cargar la app, rehidratamos si hay user en localStorage
  useEffect(() => {
    const storedToken = localStorage.getItem('accessToken');
    const storedUser  = localStorage.getItem('user');
    if (storedToken && storedUser) {
      setAccessToken(storedToken);
      setUser(JSON.parse(storedUser));
      setIsAuthenticated(true);
      API.defaults.headers.common['Authorization'] = `Bearer ${storedToken}`;
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        accessToken,
        isAuthenticated,
        login,
        logout,
        updateUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
